import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export const ReturnLines = ({ returnLines }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Return Order Lines">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Colour</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Fit</TableCell>
            <TableCell>Qty</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {returnLines?.map((line) => (
            <TableRow
              key={line.lineNo}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {line.wearerName}
              </TableCell>
              <TableCell>{line.description}</TableCell>
              <TableCell>{line.colour}</TableCell>
              <TableCell>{line.size}</TableCell>
              <TableCell>{line.fit}</TableCell>
              <TableCell>{line.qtyOrdered}</TableCell>
              <TableCell>{line.reason}</TableCell>
              <TableCell>£{line.total}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
